import { render, staticRenderFns } from "./PrivacidadeCookies.vue?vue&type=template&id=1af8ac2e&scoped=true&"
import script from "./PrivacidadeCookies.vue?vue&type=script&lang=js&"
export * from "./PrivacidadeCookies.vue?vue&type=script&lang=js&"
import style0 from "./PrivacidadeCookies.vue?vue&type=style&index=0&id=1af8ac2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af8ac2e",
  null
  
)

export default component.exports